import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';

interface InputFormProps {
  onSubmit: (content: string) => void;
  isLoading: boolean;
  initialContent?: string;
}

export function InputForm({ onSubmit, isLoading, initialContent }: InputFormProps) {
  const { t } = useTranslation();
  const [content, setContent] = useState('');

  // Update content when initialContent changes (from DevModeInjector)
  useEffect(() => {
    if (initialContent) {
      setContent(initialContent);
    }
  }, [initialContent]);

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    if (content.trim()) {
      onSubmit(content.trim());
    }
  };

  return (
    <form onSubmit={handleSubmit} className="space-y-4">
      <div>
        <label htmlFor="sms-content" className="block text-sm font-medium mb-2">
          {t('sms.inputLabel')}
        </label>
        <textarea
          id="sms-content"
          className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent"
          rows={6}
          value={content}
          onChange={(e) => setContent(e.target.value)}
          placeholder={t('sms.inputPlaceholder')}
          disabled={isLoading}
          maxLength={5000}
        />
        <div className="text-sm text-gray-500 mt-1">
          {content.length} / 5000 {t('sms.characters')}
        </div>
      </div>
      <button
        type="submit"
        disabled={isLoading || !content.trim()}
        className="w-full bg-blue-600 text-white py-3 px-6 rounded-lg font-medium hover:bg-blue-700 disabled:bg-gray-300 disabled:cursor-not-allowed transition-colors"
      >
        {isLoading ? t('sms.analyzing') : t('sms.analyzeButton')}
      </button>
    </form>
  );
}
